import { render, staticRenderFns } from "./VaccineCheckList.vue?vue&type=template&id=c588d4b2&scoped=true&"
import script from "./VaccineCheckList.vue?vue&type=script&lang=js&"
export * from "./VaccineCheckList.vue?vue&type=script&lang=js&"
import style0 from "./VaccineCheckList.vue?vue&type=style&index=0&id=c588d4b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c588d4b2",
  null
  
)

export default component.exports